import request from '@/utils/http'

/**
 * 保存网站SEO配置及推送
 * @param payload
 */
export function native_save_seo(payload) {
    return request({ url: '/client/Native/seo', method: 'post', data: payload })
}